var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlansActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21096_34031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 1,
    width: 15,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18876 13.7937L9.02607 13.7801C6.95449 13.5903 5.91869 13.4967 5.58925 12.7877C5.26116 12.08 5.85769 11.2286 7.04939 9.52441L11.907 2.58433C12.6947 1.45906 13.0892 0.896429 13.4295 1.01574C13.7685 1.1364 13.7224 1.82105 13.6329 3.19171L13.3563 7.32538C13.2723 8.57267 13.2316 9.19631 13.5895 9.6166C13.9488 10.0369 14.5711 10.0925 15.8157 10.2063L15.9783 10.2199C18.0499 10.4097 19.0857 10.5033 19.4152 11.2123C19.7433 11.92 19.1467 12.7714 17.9537 14.4756L13.0974 21.4157C12.3097 22.5409 11.9152 23.1036 11.5749 22.9843C11.2359 22.8636 11.282 22.179 11.3715 20.8083L11.6481 16.6746C11.7321 15.4273 11.7728 14.8037 11.4149 14.3834C11.0556 13.9631 10.4333 13.9075 9.18876 13.7937Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21096_34031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.76953 -4.26855H28.7684V28.2694H-3.76953V-4.26855Z",
    fill: "#204887"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansActive);
export default __webpack_public_path__ + "static/media/Plans_Active.dd5f5bdfdafe8a07ee529f9f12bd76bf.svg";
export { ForwardRef as ReactComponent };